import endpoints from "constants/endpoints";
import { adminApi } from "services/api/client";

export const getProfile = async () => {
  return await adminApi({
    endpoint: endpoints.USER_PROFILE,
    method: "get",
  });
};

export const getLeaderBoard = async (data) => {
  return await adminApi({
    endpoint: endpoints.USER_LEADERBOARD,
    method: "get",
    params: data,
  });
};

export const getLeaderBoardFilters = async () => {
  return await adminApi({
    endpoint: endpoints.USER_LEADERBOARD_FILTER,
    method: "get",
  });
};
